var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.4496 20.3669L37.1163 27.0335H66.5413V60.3669H13.208V20.3669H30.4496ZM33.2163 13.7002H13.2163C11.4554 13.7112 9.77042 14.4184 8.52918 15.6675C7.28793 16.9165 6.59127 18.6059 6.59131 20.3669V60.3669C6.59131 62.135 7.29369 63.8307 8.54393 65.0809C9.79417 66.3311 11.4899 67.0335 13.258 67.0335H66.5913C68.3594 67.0335 70.0551 66.3311 71.3054 65.0809C72.5556 63.8307 73.258 62.135 73.258 60.3669V27.0335C73.258 25.2654 72.5556 23.5697 71.3054 22.3195C70.0551 21.0692 68.3594 20.3669 66.5913 20.3669H39.9246L33.2163 13.7002Z",
    fill: "#9DA0A5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyFolder);
export default __webpack_public_path__ + "static/media/empty-folder.1446edaa9504404bc7c418dfce2d356c.svg";
export { ForwardRef as ReactComponent };